export const nav = {
  items: [
    {
      name: 'Registrations',
      url: '/registrations',
      icon: 'icon-contact-add-profile',
      badge: {
        variant: 'primary',
      },
      attributes: {
        title: 'Registrations',
      },
    },
    {
      name: 'Tenants',
      url: '/tenants',
      icon: 'icon-contact-crowd-support',
      attributes: {
        title: 'Tenants',
      },
    },
  ],
};
